export const VEGA_SPECS = require('../../public/spec/vega/index.json');
export const VEGA_LITE_SPECS = require('../../public/spec/vega-lite/index.json');
